import {useLands} from '#/hooks/query/use-lands';
import {usePortfolioLandAssets} from '#/hooks/query/use-portfolio-land-assets';
import {Land, TransactionPortfolioValue} from '@shareland/shareland-common';
import {Hex} from 'viem';

type LandGroup = {
  land: Land;
  portfolioValue: TransactionPortfolioValue;
};

export const usePortfolioLandsAndAssets = (account: Hex | undefined) => {
  const {data: lands = [], isLoading: landsIsLoading, error: landsError} = useLands();
  const {
    data: portfolioLandAssets = [],
    isLoading: portfolioLandAssetsIsLoading,
    error: portfolioLandAssetsError,
  } = usePortfolioLandAssets(account);

  return {
    data: lands
      .map(land => {
        const portfolioValue = portfolioLandAssets.find(landAsset => landAsset.landId === land.id);
        return {
          land,
          portfolioValue,
        };
      })
      .filter((entry): entry is LandGroup => !!entry.portfolioValue),
    isLoading: landsIsLoading || portfolioLandAssetsIsLoading,
    error: (landsError as Error) || (portfolioLandAssetsError as Error) || null,
  };
};
